import { Bleed, Icon, Text } from "@shopify/polaris"
import { ChevronDownIcon, ChevronUpIcon } from "polaris-enhance"
import { ReactNode } from "react"

import styles from "./QuickSetup.module.scss"

interface QuickSetupGroupProps {
  title: string
  expanded: boolean
  onToggle: () => void
  children: ReactNode
}

export default function QuickSetupGroup({
  title,
  expanded,
  onToggle,
  children,
}: QuickSetupGroupProps) {
  return (
    <div className={styles.group}>
      <div className={styles.groupHeader} onClick={onToggle}>
        <Text variant="bodySm" as="span" tone="subdued">
          {title}
        </Text>
        <div className={styles.groupChevron}>
          <Icon
            source={expanded ? ChevronUpIcon : ChevronDownIcon}
            tone="subdued"
          />
        </div>
      </div>
      {expanded && <div className={styles.groupBody}>{children}</div>}
    </div>
  )
}
